/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPromotionalBalanceGetResponseFromDiscriminatorValue, serializePromotionalBalancePostRequest, type PromotionalBalanceGetResponse, type PromotionalBalancePostRequest } from '../models';
// @ts-ignore
import { type WithPromotionalBalanceItemRequestBuilder, WithPromotionalBalanceItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /promotionalbalances
 */
export interface PromotionalbalancesRequestBuilder extends BaseRequestBuilder<PromotionalbalancesRequestBuilder> {
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.promotionalbalances.item collection
     * @param promotionalBalanceId The Guid identifier of the promotional balance to retrieve
     * @returns {WithPromotionalBalanceItemRequestBuilder}
     */
     byPromotionalBalanceId(promotionalBalanceId: Guid) : WithPromotionalBalanceItemRequestBuilder;
    /**
     * Retrieves a list of all promotional balances
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PromotionalBalanceGetResponse[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<PromotionalBalanceGetResponse[] | undefined>;
    /**
     * Creates a new promotional balance
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     */
     post(body: PromotionalBalancePostRequest, requestConfiguration?: RequestConfiguration<PromotionalbalancesRequestBuilderPostQueryParameters> | undefined) : Promise<Guid | undefined>;
    /**
     * Retrieves a list of all promotional balances
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Creates a new promotional balance
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: PromotionalBalancePostRequest, requestConfiguration?: RequestConfiguration<PromotionalbalancesRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
/**
 * Creates a new promotional balance
 */
export interface PromotionalbalancesRequestBuilderPostQueryParameters {
    creditCardId?: Guid;
}
/**
 * Uri template for the request builder.
 */
export const PromotionalbalancesRequestBuilderUriTemplate = "{+baseurl}/promotionalbalances{?creditCardId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const PromotionalbalancesRequestBuilderNavigationMetadata: Record<Exclude<keyof PromotionalbalancesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byPromotionalBalanceId: {
        requestsMetadata: WithPromotionalBalanceItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["promotionalBalanceId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const PromotionalbalancesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: PromotionalbalancesRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createPromotionalBalanceGetResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: PromotionalbalancesRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializePromotionalBalancePostRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
